import { create } from 'zustand';
import type { LoanSelectionStore } from './loanSelectionStore.types';

// Starts null so SSR never seeds this from a previous request; pages derive
// the initial value from their own request-scoped query params instead.
export const useLoanSelectionStore = create<LoanSelectionStore>((set) => ({
  loanSelection: null,
  setLoanSelection: (props) => set({ loanSelection: props }),
}));
